import React from "react";
import { motion } from "framer-motion";
import { Zap, Users, Palette, Clock, Shield, Smile } from "lucide-react";

const features = [
  {
    icon: Zap,
    title: "Anında Sonuç",
    description:
      "AI teknolojimiz ile fotoğraflarınız saniyeler içinde işleniyor.",
    gradient: "from-yellow-400 to-orange-500",
  },
  {
    icon: Users,
    title: "Etkinlik Dostu",
    description:
      "Düğün, doğum günü, kurumsal etkinlikler - her organizasyon için ideal!",
    gradient: "from-purple-400 to-pink-500",
  },
  {
    icon: Palette,
    title: "100+ Tema",
    description:
      "Süper kahramanlardan sanat eserlerine, fantastik dünyalardan vintage stillere.",
    gradient: "from-pink-400 to-rose-500",
  },
  {
    icon: Clock,
    title: "7/24 Destek",
    description:
      "Teknik ekibimiz her zaman yanınızda, sorunsuz bir etkinlik için.",
    gradient: "from-cyan-400 to-blue-500",
  },
  {
    icon: Shield,
    title: "Güvenli & Gizli",
    description: "Verileriniz güvende. Fotoğraflarınız sadece sizinle kalır.",
    gradient: "from-green-400 to-emerald-500",
  },
  {
    icon: Smile,
    title: "Sınırsız Eğlence",
    description:
      "Misafirleriniz saatlerce eğlenir, siz unutulmaz anılar biriktirirsiniz!",
    gradient: "from-rose-400 to-purple-500",
  },
];

export function Features() {
  return (
    <section className="py-20 px-4 relative">
      <div className="container mx-auto max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-cyan-400 via-purple-400 to-pink-400 bg-clip-text text-transparent">
            Neden Eyay Booth?
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            En modern AI teknolojisi ile donatılmış fotoğraf kioskumuz,
            etkinliğinizi unutulmaz kılıyor
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                whileHover={{ y: -10 }}
                className="group relative"
              >
                <div className="relative bg-gray-900/50 backdrop-blur-sm rounded-2xl p-8 border border-gray-800 hover:border-purple-500/50 transition-all duration-300 h-full">
                  {/* Glowing effect on hover */}
                  <div
                    className={`absolute inset-0 rounded-2xl bg-gradient-to-r ${feature.gradient} opacity-0 group-hover:opacity-20 blur-xl transition-opacity duration-300`}
                  ></div>

                  {/* Icon Container */}
                  <div
                    className={`relative w-16 h-16 rounded-xl bg-gradient-to-r ${feature.gradient} p-0.5 mb-6 group-hover:scale-110 transition-transform duration-300`}
                  >
                    <div className="w-full h-full bg-gray-900 rounded-xl flex items-center justify-center">
                      <Icon className="w-8 h-8 text-white" />
                    </div>
                  </div>

                  {/* Content */}
                  <h3 className="text-2xl font-bold text-white mb-4 group-hover:text-transparent group-hover:bg-gradient-to-r group-hover:from-white group-hover:to-purple-400 group-hover:bg-clip-text transition-all duration-300">
                    {feature.title}
                  </h3>
                  <p className="text-gray-400 leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
